import React, { useEffect, useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, GradeOptions, StudentSexOptions } from "../../../../../../../../_helpers/Helpers";
import { useStudentsUIContext } from "../StudentsUIContext";

const prepareFilter = (queryParams, values) => {
  let { term, studentName, studentSurname, grade, section, sex } = values;
  const newQueryParams = { ...queryParams };
  const filter = { studentName, studentSurname, grade, section, sex };
  newQueryParams.filter = filter;
  newQueryParams.term = term
  return newQueryParams;
};

export function StudentsFilter({
  term
}) {
  // Students UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      setQueryParams: studentsUIContext.setQueryParams,
      queryParams: studentsUIContext.queryParams,
    };
  }, [studentsUIContext]);

  useEffect(() => { 
    applyTermFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [term]);

  const applyTermFilter = () => {
    const newQueryParams = { ...studentsUIProps.queryParams };
    newQueryParams.term = term;
    newQueryParams.pageNumber = 1;
    studentsUIProps.setQueryParams(newQueryParams);
  };

  const applyFilter = (values) => {
    values.term = term;
    const newQueryParams = prepareFilter(studentsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, studentsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      studentsUIProps.setQueryParams(newQueryParams);
    }
  };

  const gradeOptions = FilterOptions.concat(GradeOptions);
  const sexOptions = FilterOptions.concat(StudentSexOptions);

  return (
    <Formik
      initialValues={{
        studentName: "",
        studentSurname: "",
        section: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="studentName"
                placeholder="Öğrenci Adı"
                onBlur={handleBlur}
                value={values.studentName}
                onChange={(e) => {
                  setFieldValue("studentName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="studentSurname"
                placeholder="Öğrenci Soyadı"
                onBlur={handleBlur}
                value={values.studentSurname}
                onChange={(e) => {
                  setFieldValue("studentSurname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeOptions}
                value={values.grade}
                placeholder="Sınıfı"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("grade", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıfı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="section"
                placeholder="Şube"
                onBlur={handleBlur}
                value={values.section}
                onChange={(e) => {
                  setFieldValue("section", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Şube</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={sexOptions}
                value={values.sex}
                placeholder="Cinsiyeti"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sex", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Cinsiyeti</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}